module.exports = __webpack_public_path__ + "static/assets/cb57d2439ceea568e13014abcc084c3a.png";